import { render, staticRenderFns } from "./MagnifyToggle.vue?vue&type=template&id=6359c18e"
import script from "./MagnifyToggle.vue?vue&type=script&lang=js"
export * from "./MagnifyToggle.vue?vue&type=script&lang=js"
import style0 from "./MagnifyToggle.vue?vue&type=style&index=0&id=6359c18e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports